<template>
<!-- Container布局容器 用组件的形式来写 高度为视口高度 -->
	<el-container>
		<!-- 要多高、padding必须自己设置 element有默认 -->
		<!-- 主要内容 -->
		<el-main class="main">
			<Main></Main>
		</el-main>
	</el-container>
</template>

<script>
import Main from '@/layout_mobile/main';
export default {
	data() {
		return {
		}
	},
	components: {
		Main,
	},
	computed: {

	},
	created () {
		if(!this._isMobile()){
			// alert('手机端')
			// this.$router.replace('Mobile_web')

			this.$router.replace({name:'PC'})
		}
	},
	methods: {
		// 判断是PC端还是移动端
		_isMobile(){
			let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
			return flag
		}
	}
}
</script>

<style lang="scss" scoped>
// lang="scss"(可以叠写css) scoped(局部作用域) 

.main{
	padding:0px;
	// 解决main自带的滚动条
	position: absolute;
	top:0;
	bottom: 0;
	right: 0;
	left: 0;
}
</style>
